export const DEFAULT_RESULTS_PER_PAGE = Number(process.env.RESULTS_PER_PAGE) || 20;
export const MAIN_SLIDER_NAVIGATION_MODE = (process.env.MAIN_SLIDER_NAVIGATION_MODE || "auto") as "auto"|"manual";
export const REQUEST_MAX_ATTEMPTS = Number(process.env.REQUEST_MAX_ATTEMPTS) || 5;
export const REQUEST_RETRY_DELAY = Number(process.env.REQUEST_RETRY_DELAY) || 1;
export const DEBOUNCE_TIMEOUT = 350;